"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("../../constants/index.js");

var _index2 = require("../../utils/index.js");

var INCA = _index.urlParams.INCA;

var internalCampaign = function internalCampaign(event) {
  var inca = (0, _index2.getUrlParams)(INCA);
  if (!inca) return event;
  var intCampaign = {
    productListItems: [{
      name: 'int_cmp_clk',
      _telus: {
        internalCampaignName: inca,
        campaignClick: 1
      }
    }],
    commerce: {
      _telus: {
        prodFinding: {
          internalCampaignName: inca,
          productFindingMethod: 'internal_campaign',
          categoryPath: 'non-category_browse',
          reco: 'non-recs',
          search: 'non-search'
        }
      }
    }
  };
  event.xdm = (0, _index2.mergeObjects)(event.xdm, intCampaign);
  return event;
};

var _default = internalCampaign;
exports["default"] = _default;